const reorderArray = (event, array) => {
  const remainItems = array.filter((item, index) => index !== event.prevIndex);
  remainItems.splice(event.newIndex, 0, array[event.prevIndex]);
  return remainItems;
};

export default reorderArray;
